import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./FeedbackForm.css";
import Swal from "sweetalert2";

const FeedbackForm = () => {
  const { encodedId } = useParams(); // Capture encodedId from URL
  const navigate = useNavigate();
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [capturedId, setCapturedId] = useState(null);

  useEffect(() => {
    if (encodedId) {
      setCapturedId(encodedId); // Store the encodedId internally
      navigate("/", { replace: true })}
    }, [encodedId, navigate]);

  const handleRating = (value) => {
    setRating(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    console.log("Encoded ID:", capturedId);
    console.log("Rating:", rating);
    console.log("Feedback:", feedback);
  
    const feedbackData = {
      feedback: feedback,
      ratings: rating,
      encodedId: capturedId, // Use stored ID
    };
  
    // Log the request body before sending
    console.log("Request Body:", JSON.stringify(feedbackData, null, 2));
  
    try {
      const response = await fetch(process.env.REACT_APP_FEEDBACK_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_AUTH_TOKEN,
        },
        body: JSON.stringify(feedbackData),
      });
  
      if (response.ok) {
        document.body.style.overflow = "visible"; // Disable scrolling when modal appears
        Swal.fire({
          title: "Thank You!",
          text: "Your feedback has been submitted.",
          icon: "success",
          confirmButtonText: "OK",
          heightAuto: false,
          customClass: {
            popup: "swal-custom", // Main modal box
            title: "swal-title", // Title styling
            htmlContainer: "swal-text", // Text styling
            confirmButton: "swal-button", // Confirm button styling
          },
        });
        
  
        setFeedback("");
        setRating(0);
        setIsSubmitted(false);
        
      } else {
        Swal.fire({
          title: "Oops!",
          text: "Something went wrong! Please try again.",
          icon: "error",
          confirmButtonText: "OK",
          heightAuto: false,
          customClass: {
            popup: "swal-custom", // Main modal box
            title: "swal-title", // Title styling
            htmlContainer: "swal-text", // Text styling
            confirmButton: "swal-button", // Confirm button styling
          },
        });
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      Swal.fire({
        title: "Error!",
        text: "An error occurred while submitting feedback.",
        icon: "error",
        confirmButtonText: "OK",
        heightAuto: false,
        customClass: {
          popup: "swal-custom", // Main modal box
          title: "swal-title", // Title styling
          htmlContainer: "swal-text", // Text styling
          confirmButton: "swal-button", // Confirm button styling
        },
      });
    }
  };
  

  return (
    <div className="feedback-container">
      <div className="profile-card">
        <h1 className="heading">Trial Feedback</h1>
        <form onSubmit={handleSubmit} className={`feedback-form ${isSubmitted ? "submitted" : ""}`}>
          <div className="form-group">
            <label className="subHeading">Rate your trial experience:</label>
            <div className="stars">
              {[1, 2, 3, 4, 5].map((value) => (
                <span
                  key={value}
                  className={`star ${value <= (hoverRating || rating) ? "selected" : ""}`}
                  onClick={() => handleRating(value)}
                  onMouseEnter={() => setHoverRating(value)}
                  onMouseLeave={() => setHoverRating(0)}
                >
                  {value <= (hoverRating || rating) ? "⭐" : "☆"}
                </span>
              ))}
            </div>
          </div>
          <div className="form-group">
            <label className="subHeading">Feedback:</label>
            <textarea
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
              placeholder="Enjoyed the trial? Share your experience with us!"
              style={{ color: "white", backgroundColor: "transparent" }}
              required
            />
          </div>
          <button type="submit" disabled={rating === 0} className="submit-button">
            Submit Feedback 🚀
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm;